/**
 * Pure validation for emoji message payloads.
 */

import { EMOJI_IDS, type EmojiId } from "./types";

interface ValidationResult {
  readonly valid: boolean;
  readonly error?: string;
}

const VALID_EMOJI_SET: ReadonlySet<string> = new Set(EMOJI_IDS);

export function validateEmojiId(emojiId: unknown): ValidationResult {
  if (typeof emojiId !== "string") {
    return { valid: false, error: "emojiId must be a string" };
  }
  if (!VALID_EMOJI_SET.has(emojiId)) {
    return { valid: false, error: `Invalid emojiId: ${emojiId}` };
  }
  return { valid: true };
}

export function isValidEmojiId(value: unknown): value is EmojiId {
  return typeof value === "string" && VALID_EMOJI_SET.has(value);
}
